module.exports = __webpack_public_path__ + "img/reward_light.6fb57bdd.png";